/*
 * @Author: huangyan
 * @Date: 2021-09-29 17:08:56
 * @Description: 购物车模块
 */
import { goodsCartList, goodsCartCountsTotal } from "@/api/goodsCart";
import { getToken } from "@/utils/auth";

const state = {
    carts: [],
    cartNum: 0
};

function updateCartNum(state, num) {
    if (!isNaN(num)) {
        state.cartNum = Number(num);
    } else {
        // state.cartNum = state.carts.reduce((pre, current) => {
        // 	return pre + current.counts
        // }, 0)
    }
}

const mutations = {
    CARTS(state, info) {
        if (Array.isArray(info)) {
            state.carts = info.map(item => ({
                cartId: item.id,
                goodsId: item.goodsId,
                counts: item.counts
            }));
        } else {
            const index = state.carts.findIndex(
                item => item.cartId == info.cartId
            );
            if (index != -1) {
                state.carts.splice(index, 1, info);
            } else {
                state.carts.push(info);
            }
        }
        // updateCartNum(state)
    },
    CARTS_REMOVE(state, cartId) {
        const index = state.carts.findIndex(item => item.cartId == cartId);
        if (index !== -1) {
            state.carts.splice(index, 1);
        }
        // updateCartNum(state)
    },
    UPDATE_CART_NUM(state, num) {
        state.cartNum = num;
    }
};

const actions = {
    // 获取购物车数据
    getCarts({ commit }, data = {}) {
        // goodsCartList(data).then(res => {
        // 	commit('CARTS', res.data.datas)
        // })
    },
    getGoodsCartCountsTotal({ commit }, data = {}) {
        if (!getToken()) {
            console.log("当前未登录");
            return;
        } else {
            goodsCartCountsTotal().then(res => {
                commit("UPDATE_CART_NUM", res.data);
            });
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
